import { CUBICLE_VIEW2, UPDATE_BEDSTATUS_VIEW, GET_BEDSTATUS_VIEW } from '../../constant';

const initialState = {
  defaultViewType: CUBICLE_VIEW2,
  currentViewType: CUBICLE_VIEW2,
  isCubicleV2: false,
};

const BedStatusViewReducer = (state = initialState, action) => {
  const { type, viewVal } = action;
  switch (type) {
    case GET_BEDSTATUS_VIEW:
      return state;
    case UPDATE_BEDSTATUS_VIEW:
      return {
        ...state,
        ...viewVal,
      };
    default:
      return state;
  }
};

export default BedStatusViewReducer;
